/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBillingTransactionDocument {
    getFixupPrototypeFunction() { return MasterAccountBillingTransactionDocument.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBillingTransactionDocument>): MasterAccountBillingTransactionDocument {
        let obj = Object.assign(new MasterAccountBillingTransactionDocument(), model);
        MasterAccountBillingTransactionDocument.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBillingTransactionDocument>): MasterAccountBillingTransactionDocument {
        if (!model) return null;
        return MasterAccountBillingTransactionDocument.newInstance(<MasterAccountBillingTransactionDocument> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBillingTransactionDocument) {
        if (!obj) return;

        models.MasterAccountBillingTransactionDocument.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBillingTransactionDocument): boolean {
        Object.setPrototypeOf(obj, MasterAccountBillingTransactionDocument.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.amount === undefined) {
            this.amount = 0;
        }
        if (this.previous_balance === undefined) {
            this.previous_balance = 0;
        }
        if (this.after_balance === undefined) {
            this.after_balance = 0;
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.processed_at === "string") {
            this.processed_at = new Date(<string><any>this.processed_at);
        }
    }

    /**
     * Id of the document.
     */
    sysId: string;

    /**
     * Transaction id for the balance update
     */
    transaction_id: string;

    /**
     * Id of the tenant where the balance is updated.
     */
    tenant_id: string;

    /**
     * Id of conversation where the balance is updated.
     */
    conversation_id: string;

    /**
     * Id of master account where the balance is updated.
     */
    master_account_id: string;

    /**
     * Amount for the transaction.
     */
    amount: number;

    /**
     * Type of billing transaction.
     */
    transaction_type: models.BillingTransactionType;

    /**
     * Balance before the transaction.
     */
    previous_balance: number;

    /**
     * Balance after the transaction.
     */
    after_balance: number;

    /**
     * Type of billing transaction status.
     */
    status: models.BillingTransactionStatus;

    /**
     * Name of the user who made the balance update.
     */
    created_by: string;

    /**
     * Time when the transaction is initiated.
     */
    created_at: Date;

    /**
     * Time when the transaction is completed.
     */
    processed_at: Date;

}
